import React, {forwardRef, useImperativeHandle, useState} from "react";
import {useQueryClient} from "react-query";
import __ from "lodash";
import { InputLabel, Select, MenuItem, FormControl, TextField } from "@material-ui/core";
import {useComboValues} from "../services/settings";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const ComboSelect = forwardRef((props, ref) => {
  const {id, label, readOnly, disabled, renderValue, style, fullWidth, displayOnly, filter} = props;
  const classNames = [props.className];
  if (props.readOnly) {
    classNames.push('readOnly');
  }
  let value = props.value;
  if (value && typeof value === "object") {
    if (!__.isEmpty(value))
      value = value.code;
    else
      value = "";
  }
  const className = classNames.join(" ");
  const isDataGrid = props.isdatagrid || false;
  const [oldValue, setOldValue] = useState(value);
  const [controlValue, setControlValue] = useState(`${value}`);
  const [selectedCombo, setSelectedCombo] = useState(undefined);

  if (value !== oldValue) {
    setOldValue(value);
    setControlValue(`${value}`);
  }

  const queryClient = useQueryClient();
  const extraKeys = props.subGroup?[props.group, props.subGroup]:[props.group]

  const comboValues = useComboValues({queryClient, extraKeys, useCache: true});

  let filteredComboValues = [];
  if (comboValues && Array.isArray(comboValues.data)) {
    filteredComboValues = comboValues.data;
    if (typeof props.filter === "function") {
      filteredComboValues = props.filter(filteredComboValues);
    }
    if (typeof props.sort === "function") {
      filteredComboValues = props.sort(filteredComboValues)
    }
  }

  const onChangeHandler = (event) => {
    if (props.onChange && props.returnType !== "object" && props.returnType !== "objectOnly") {
      props.onChange(event.target.value);
    }
    setControlValue(event.target.value);
    let selectedRecord = __.find(comboValues.data, {code: event.target.value});
    if (selectedRecord) {
      setSelectedCombo(selectedRecord);
    } else {
      selectedRecord = __.find(comboValues.data, {value: event.target.value});
      if (selectedRecord) {
        setSelectedCombo(selectedRecord);
      }
    }
    if (props.onChange && props.returnType === "object") {
      props.onChange(event.target.value, selectedRecord);
    }
    if (props.onChange && props.returnType === "objectOnly") {
      props.onChange(selectedRecord);
    }
  }

  useImperativeHandle(ref, () => {
    let value = {};
    // if (isDataGrid)
    //   value = selectedCombo === undefined ? {} : selectedCombo;
    // else
      value = controlValue === undefined ? {} : controlValue;

    return {
      // the final value to send to the grid, on completion of editing
      getValue() {
        return value;
      },
      // Gets called once before editing starts, to give editor a chance to
      // cancel the editing before it even starts.
      isCancelBeforeStart() {
        return false;
      },

      // Gets called once when editing is finished (eg if enter is pressed).
      // If you return true, then the result of the edit will be ignored.
      isCancelAfterEnd() {
        return false;
      },

      afterGuiAttached () {
        //inputRef.current.focus();
      },
    }
  });


  let displayValue = "";
  if (displayOnly && comboValues && filteredComboValues) {
    let code = `${value}`;
    displayValue = code;
    const option = __.find(filteredComboValues, {code});
    if (option) {
      displayValue = option.value;
    }
  }

  let labelProps = {...props.inputLabelProps};
  if (props.label && (!__.isEmpty(controlValue) || !__.has(props?.inputLabelProps, ["shrink"]))) {
    labelProps = {shrink: !__.isEmpty(controlValue)}
  }

  return (
    <>
    {displayOnly
      ? label ?
        <FormControl style={props.containerStyle} fullWidth>
          <InputLabel id={`${id}-label`} {...labelProps}>{label}</InputLabel>
          <div style={{marginTop: 20, ...props.style||{}}}>{displayValue}</div>
        </FormControl>
      :
        <div style={{...props.style||{}}}>{displayValue}</div>
      :
        <FormControl style={props.containerStyle} fullWidth>
          {label
            ?
              <InputLabel id={`${id}-label`} {...labelProps}>{label}</InputLabel>
            :
              <></>
          }
          <Select
            id={id}
            labelId={`${id}-label`}
            className={className}
            readOnly={readOnly}
            disabled={disabled}
            fullWidth={fullWidth}
            onChange={onChangeHandler}
            value={controlValue}
            style={style}
            disableUnderline={isDataGrid?true:false}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              PaperProps: {
                style: {
                  maxHeight: ITEM_HEIGHT * 9.5 + ITEM_PADDING_TOP,
                }}
            }}
            renderValue={(code) => {
              let value = code;
              if (typeof renderValue === "function"){
                value = renderValue(code, filteredComboValues);
              } else {
                const option = __.find(filteredComboValues, {code});
                if (option) {
                  value = option.value;
                } else {
                  const option = __.find(filteredComboValues, {value: code});
                  if (option)
                    value = option.value;
                }
              }
              return value;
            }}
            {...props.inputProps}
          >
            {(comboValues && Array.isArray(filteredComboValues)) ?
              filteredComboValues.map((option) => {
                return (
                  <MenuItem key={option.code} value={option.code}>{option.value}</MenuItem>);
              }) :
              null
            }
          </Select>
        </FormControl>
    }
    </>
  );
})

export default (ComboSelect);
